import { Blockquote, Amazon, Series } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Series,
  React
};